import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { inject, observer } from "mobx-react";
import plural from "plural-ru";
import styles from "./mainInfoCard.module.scss";
import screenshootStyles from './screenshoot.module.scss'
import { SHORT_BLOOD_GROUPS } from "../../../entities";
// DONATION_TYPES для капелек
import { DONATION_TYPES } from "../../../entities/profile_donation_types";
import { MainDonationTypes } from "../../profileComponents/profileDonationTypes";
import profileImg from "../../../new-images/profile/profile.svg";
import arrowImg from "../../../new-images/profile/top-arrow.svg";
import rightArrowimg from "../../../new-images/profile/right-to-arrow.svg";
import DonorPath from "../donorPath/DonorPath";
import Link from "next/link";
import { get_profile_city_label, getUserPhotoFromUser, sendMetrics } from "../../../utils/misc";
import MyButton from "../../myButton";
import { achievementsSerializer, getAchCategory } from "../../achievements/utils";
import { TakenAchievements } from "../../achievements/TakenAchievements";
import { getCountTakenAchievements } from "../../impact/utils";
import redirectTo from "../../../utils/redirectTo";
import html2canvas from 'html2canvas';
import { Popup } from "semantic-ui-react";
import getDonorTimeDuration from "../../vmesteOkean/utils/getDonorTimeDuration";

const months = {
  1: "января",
  2: "февраля",
  3: "марта",
  4: "апреля",
  5: "мая",
  6: "июня",
  7: "июля",
  8: "августа",
  9: "сентября",
  10: "октября",
  11: "ноября",
  12: "декабря",
};

const MainInfo = (props) => {
  const { honor, authStore, visibleInfo, setVisibleInfo, isLaptop } = props;
  const { user } = authStore;
  const captureRef = useRef(null);
  const userAvatar = getUserPhotoFromUser(user);
  const [loader, setLoader] = useState(true);
  // const [takenAchievements, setTakenAchievements] = useState([]);

  const numberMonths = user?.donation_agg?.last_donation_at?.split("-");

  // хэш-мап, преобразовываю числовое значание месяца в буквенное
  numberMonths && (numberMonths[1] = months[Number(numberMonths[1])]);

  const toggleVisibleInfo = () => {
    setVisibleInfo(!visibleInfo);
  };

  const getData = () => {
    setLoader(true);
    authStore
      ?.fetchCurrentUser()
      .then((data) => {
        setLoader(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getData();
    // Если в триггерном банере изменяется имя, фамилия или группа крови, то происходит запрос на данные пользователя
  }, [user?.last_name, user?.first_name]);

  useEffect(() => {
    if (!isLaptop) {
      setVisibleInfo(false);
    } else {
      setVisibleInfo(true);
    }
  }, [isLaptop]);


  const screenShot = (
    <div ref={captureRef} style={{ position: "fixed", top: "-9999px", left: "-9999px", padding: "20px", zIndex: 10000 }}>
      <div className={screenshootStyles.MainInfo}>
        <img className={screenshootStyles.DSImage} src={"/static/images/newLogoIcon.svg"} alt="" />
        <div
          className={`${screenshootStyles.MainInfo__avatar} ${screenshootStyles.Avatar}`}
        >
          {
            user?.profile_config?.photo_style !== 'default_style' &&
            <img
              src={user?.blood_group && user?.blood_group !== "dont_know"
                ? `/static/images/avatars/${user?.profile_config?.photo_style}/${user?.blood_group}.png`
                : `/static/images/avatars/${user?.profile_config?.photo_style}/without_group.png`}
              alt=""
              className={screenshootStyles.avatarRound}
            />
          }
          <img
            className={screenshootStyles.Avatar__img}
            src={userAvatar || profileImg}
            width={154}
            height={154}
            alt="avatar"
            crossOrigin="anonymous"
          />
          {user?.blood_group && user?.profile_config?.photo_style === 'default_style' && (
            <span className={`${screenshootStyles.Avatar__bloodGroup} screenshotBloodGroup`}>
              {SHORT_BLOOD_GROUPS[user?.blood_group]}
            </span>
          )}
        </div>
        <h5
          className={screenshootStyles.MainInfo__name}
          title={`${user?.first_name} ${user?.last_name ? user?.last_name : ""
            }`}
        >
          {`${user?.first_name} ${user?.last_name ? user?.last_name : ""
            }`}
        </h5>
        {user?.city?.title && (
          <p className={screenshootStyles.MainInfo__address}>
            {`${get_profile_city_label(user?.city)}`}
          </p>
        )}
        {
          authStore?.takenAchievements.length !== 0 &&
          <div className={screenshootStyles.TakenAchievements}>
            {
              authStore?.takenAchievements.slice(0, 8).map((ach, i) => (
                <div className={screenshootStyles.TakenAchievements_ach}>
                  <img src={`/static/images/achievements/${getAchCategory(ach.type)}/${ach.type}.png`} alt={ach.name} width={58} height={58} />
                  {
                    (i === authStore?.takenAchievements.slice(0, 8).length - 1 && authStore?.takenAchievements.length > 8) &&
                    <div className={screenshootStyles.TakenAchievements_ach__blur}>
                      <span>+ {authStore?.takenAchievements.length - 8}</span>
                    </div>
                  }
                </div>
              ))
            }
          </div>
        }
        <>
          <div className={screenshootStyles.MainInfo__boxShadow}></div>
          {
            user?.donation_agg?.first_donation_at &&
            <div
              className={`${screenshootStyles.MainInfo__donationDate} ${screenshootStyles.DonationDate}`}
            >
              <p><b>{getDonorTimeDuration(user?.donation_agg?.first_donation_at)}</b> в донорстве</p>
            </div>
          }
          <div className={screenshootStyles.MainInfo__donations}>
            {user?.donation_agg?.count
              ? Object.keys(DONATION_TYPES).map((key) => {
                if (user?.donation_agg)
                  if (user?.donation_agg[key])
                    return (
                      <MainDonationTypes
                        key={key}
                        tooltip={DONATION_TYPES[key]?.title}
                        icon={DONATION_TYPES[key]?.icon}
                        count={user?.donation_agg[key]}
                        iconStyle={{
                          width: "24px",
                          height: "24px",
                          margin: "8px",
                        }}
                      />
                    );
              })
              : Object.keys(DONATION_TYPES)
                .slice(0, 5)
                .map((key) => {
                  return (
                    <MainDonationTypes
                      key={key}
                      tooltip={DONATION_TYPES[key]?.title}
                      icon={DONATION_TYPES[key]?.icon}
                      count={
                        user?.donation_agg &&
                        user?.donation_agg[key]
                      }
                      iconStyle={{
                        width: "24px",
                        height: "24px",
                        margin: "8px",
                      }}
                    />
                  );
                })}
          </div>
          <div className={screenshootStyles.DonationInfo}>
            <p
              className={screenshootStyles.MainInfo__donorStatus}
              style={{
                backgroundColor: `${user?.donor_status?.background_color}`,
                color: `${user?.donor_status?.text_color}`,
              }}
            >
              {user?.donor_status?.name}
            </p>
            <div className={screenshootStyles.DonationAgg}>
              <span className={screenshootStyles.DonationAgg__count}>
                {user?.donation_agg?.count}
              </span>
              <span className={screenshootStyles.DonationAgg__text}>
                {plural(
                  user?.donation_agg?.count,
                  "донация",
                  "донации",
                  "донаций"
                )}
              </span>
            </div>
          </div>
        </>
      </div>
    </div>
  )




  const handleCaptureClick = async () => {
    if (captureRef.current) {
      // Создаем новый div с нужными стилями
      // const paddedDiv = document.createElement('div');
      // paddedDiv.style.margin = '20px';
      // paddedDiv.style.position = 'absolute';
      // paddedDiv.style.top = '-9999px';  // Перемещаем за пределы видимой области
      // paddedDiv.style.left = '-9999px';
      // paddedDiv.style.visibility = 'hidden';  // Делаем невидимым

      // Клонируем контент и добавляем его в новый div
      // paddedDiv.appendChild(captureRef.current.cloneNode(true));

      // // Временно добавляем div в DOM
      // document.body.appendChild(paddedDiv);

      const targetElement = captureRef.current.querySelector('.screenshotBloodGroup');
      if (targetElement && targetElement instanceof HTMLElement) {
        targetElement.style.boxShadow = 'none';
        targetElement.style.border = '1px solid rgba(0, 0, 0, 0.25)';
      }

      const canvas = await html2canvas(captureRef.current, {
        useCORS: true,
        ignoreElements: (element) => element.classList.contains('screenshotDisabled'),
        scale: 2
      });
      const imgData = canvas.toDataURL('image/png');

      // Создание файла из изображения
      const blob = await (await fetch(imgData)).blob();
      const file = new File([blob], 'my-profile-donorsearch.png', { type: 'image/png' });

      const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // Проверка поддержки Web Share API и возможности передачи файлов
      if (navigator.canShare && navigator.canShare({ files: [file] }) && isMobile) {
        try {
          await navigator.share({
            files: [file],
            title: 'Мой профиль в donorsearch.org',
          });
        } catch (error) {
          console.error('Sharing failed:', error);
        }
      } else {
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'my-profile-donorsearch.png';
        link.click();
      }
    }
  };

  return (
    <>
      {screenShot}
      <div
        className={
          visibleInfo
            ? styles.MainInfoComponent
            : styles.MainInfoComponentMobile
        }
      >
        <div className={`${styles.Show} ${!loader ? styles.Content : ""}`}>
          {visibleInfo ? (
            isLaptop ? (
              <>
                <div className={styles.MainInfo}>
                  <div className={styles.settingsSVG} onClick={() => redirectTo('/profile/settings/general/')}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5Z" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M16.351 8.66234L15.4368 6.454L16.666 4.99984L14.9993 3.33317L13.5535 4.569L11.2977 3.6415L10.7785 1.6665H9.15018L8.62352 3.66734L6.41935 4.5965L4.99935 3.33317L3.33268 4.99984L4.54352 6.49067L3.64352 8.70484L1.66602 9.1665V10.8332L3.66685 11.379L4.59602 13.5832L3.33268 14.9998L4.99935 16.6665L6.49185 15.4498L8.66352 16.3432L9.16602 18.3332H10.8327L11.336 16.344L13.5452 15.429C13.9135 15.6923 14.9993 16.6665 14.9993 16.6665L16.666 14.9998L15.4293 13.5415L16.3443 11.3315L18.3327 10.8148V9.1665L16.351 8.66234Z" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <div
                    className={`${styles.MainInfo__avatar} ${styles.Avatar}`}
                  >
                    {
                      user?.profile_config?.photo_style !== 'default_style' &&
                      <img
                        src={user?.blood_group && user?.blood_group !== "dont_know"
                          ? `/static/images/avatars/${user?.profile_config?.photo_style}/${user?.blood_group}.png`
                          : `/static/images/avatars/${user?.profile_config?.photo_style}/without_group.png`}
                        alt=""
                        className={styles.avatarRound}
                      />
                    }
                    <Image
                      className={styles.Avatar__img}
                      src={userAvatar || profileImg}
                      loader={() => userAvatar || profileImg}
                      width={154}
                      height={154}
                      alt="avatar"
                      crossOrigin="anonymous"
                      onClick={() => redirectTo('/profile/settings/personal')}
                    />
                    {user?.blood_group && user?.profile_config?.photo_style === 'default_style' && (
                      <span className={`${styles.Avatar__bloodGroup} screenshotBloodGroup`}>
                        {SHORT_BLOOD_GROUPS[user?.blood_group]}
                      </span>
                    )}
                  </div>
                  <h5
                    className={styles.MainInfo__name}
                    title={`${user?.first_name} ${user?.last_name ? user?.last_name : ""
                      }`}
                  >
                    {`${user?.first_name} ${user?.last_name ? user?.last_name : ""
                      }`}
                  </h5>
                  {user?.city?.title && (
                    <p className={styles.MainInfo__address}>
                      {`${get_profile_city_label(user?.city)}`}
                    </p>
                  )}
                  {
                    authStore?.takenAchievements.length !== 0 &&
                    <>
                      <TakenAchievements takenAchievements={authStore?.takenAchievements} />
                      <div
                        onClick={handleCaptureClick}
                        className={styles.shareButtonTop}
                      >
                        <span>Рассказать друзьям</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 6H17.8C16.1198 6 15.2798 6 14.638 6.32698C14.0735 6.6146 13.6146 7.07354 13.327 7.63803C13 8.27976 13 9.11984 13 10.8V12M21 6L18 3M21 6L18 9M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14" stroke="#F73E3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                    </>
                  }
                  <>
                    <div className={styles.MainInfo__boxShadow}></div>
                    {
                      user?.donation_agg?.first_donation_at &&
                      <div
                        className={`${styles.MainInfo__donationDate} ${styles.DonationDate}`}
                      >
                        <p><b>{getDonorTimeDuration(user?.donation_agg?.first_donation_at)}</b> в донорстве</p>
                      </div>
                    }
                    <div className={styles.MainInfo__donations}>
                      {user?.donation_agg?.count
                        ? Object.keys(DONATION_TYPES).map((key) => {
                          if (user?.donation_agg)
                            if (user?.donation_agg[key])
                              return (
                                <MainDonationTypes
                                  key={key}
                                  tooltip={DONATION_TYPES[key]?.title}
                                  icon={DONATION_TYPES[key]?.icon}
                                  count={user?.donation_agg[key]}
                                  iconStyle={{
                                    width: "24px",
                                    height: "24px",
                                    margin: "8px",
                                  }}
                                />
                              );
                        })
                        : Object.keys(DONATION_TYPES)
                          .slice(0, 5)
                          .map((key) => {
                            return (
                              <MainDonationTypes
                                key={key}
                                tooltip={DONATION_TYPES[key]?.title}
                                icon={DONATION_TYPES[key]?.icon}
                                count={
                                  user?.donation_agg &&
                                  user?.donation_agg[key]
                                }
                                iconStyle={{
                                  width: "24px",
                                  height: "24px",
                                  margin: "8px",
                                }}
                              />
                            );
                          })}
                    </div>
                    <div className={styles.DonationInfo}>
                      <p
                        className={styles.MainInfo__donorStatus}
                        style={{
                          backgroundColor: `${user?.donor_status?.background_color}`,
                          color: `${user?.donor_status?.text_color}`,
                        }}
                      >
                        {user?.donor_status?.name}
                      </p>
                      <div className={styles.DonationAgg}>
                        <span className={styles.DonationAgg__count}>
                          {user?.donation_agg?.count}
                        </span>
                        <span className={styles.DonationAgg__text}>
                          {plural(
                            user?.donation_agg?.count,
                            "донация",
                            "донации",
                            "донаций"
                          )}
                        </span>
                      </div>
                    </div>
                    <div className={styles.buttons}>
                      <Link href={"/profile/add_donation/"}>
                        <div className={`${styles.MainInfo__addDonationBtn} screenshotDisabled`}>
                          <MyButton
                            text={"Добавить донацию"}
                            width={"100%"}
                            containerWidth={"100%"}
                            onClick={() => {
                              sendMetrics("to_add_donation_from_profile");
                            }}
                          />
                        </div>
                      </Link>
                    </div>
                  </>
                </div>
                <div className={styles.Mobile}>
                  <DonorPath honor={honor} />
                </div>
              </>
            ) : (
              <>
                <div className={styles.MainInfoMobile}>
                  <div className={styles.settingsSVG} onClick={() => redirectTo('/profile/settings/general/')}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5Z" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M16.351 8.66234L15.4368 6.454L16.666 4.99984L14.9993 3.33317L13.5535 4.569L11.2977 3.6415L10.7785 1.6665H9.15018L8.62352 3.66734L6.41935 4.5965L4.99935 3.33317L3.33268 4.99984L4.54352 6.49067L3.64352 8.70484L1.66602 9.1665V10.8332L3.66685 11.379L4.59602 13.5832L3.33268 14.9998L4.99935 16.6665L6.49185 15.4498L8.66352 16.3432L9.16602 18.3332H10.8327L11.336 16.344L13.5452 15.429C13.9135 15.6923 14.9993 16.6665 14.9993 16.6665L16.666 14.9998L15.4293 13.5415L16.3443 11.3315L18.3327 10.8148V9.1665L16.351 8.66234Z" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <div className={styles.Screen}>
                    <div className={styles.ScreenHeader}>
                      <div className={styles.ScreenHeader_Avatar}>
                        <div className={styles.avaWrapper}>
                          {
                            user?.profile_config?.photo_style !== 'default_style' &&
                            <img
                              src={user?.blood_group && user?.blood_group !== "dont_know"
                                ? `/static/images/avatars/${user?.profile_config?.photo_style}/${user?.blood_group}.png`
                                : `/static/images/avatars/${user?.profile_config?.photo_style}/without_group.png`}
                              alt=""
                              className={`${styles.avatarRound} ${styles.avatarRoundFull}`}
                            />
                          }
                          <Image
                            className={styles.ScreenHeaderImg}
                            src={userAvatar || profileImg}
                            loader={() => userAvatar || profileImg}
                            width={65}
                            height={65}
                            alt="avatar"
                            onClick={() => redirectTo('/profile/settings/personal')}
                          />
                        </div>
                        {user?.blood_group && user?.profile_config?.photo_style === 'default_style' && (
                          <span className={styles.Avatar__bloodGroup}>
                            {SHORT_BLOOD_GROUPS[user?.blood_group]}
                          </span>
                        )}
                      </div>
                      <div className={styles.ScreenHeaderInfo}>
                        <p className={styles.ScreenHeaderInfoName}>
                          {user?.first_name}{" "}
                          {user?.last_name ? user?.last_name : ""}
                        </p>
                      </div>
                    </div>
                    <div className={styles.ScreenFooter}>
                      {
                        authStore?.takenAchievements.length !== 0 &&
                        <TakenAchievements takenAchievements={authStore?.takenAchievements} />
                      }
                    </div>
                  </div>
                </div>
                <div className={styles.Donations}>
                  <div className={styles.MainInfo__boxShadow}></div>
                  {
                    user?.donation_agg?.first_donation_at &&
                    <div
                      className={`${styles.MainInfo__donationDate} ${styles.DonationDate}`}
                    >
                      <p><b>{getDonorTimeDuration(user?.donation_agg?.first_donation_at)}</b> в донорстве</p>
                    </div>
                  }
                  <div className={styles.MainInfo__donations}>
                    {user?.donation_agg?.count
                      ? Object.keys(DONATION_TYPES).map((key) => {
                        if (user?.donation_agg)
                          if (user?.donation_agg[key])
                            return (
                              <MainDonationTypes
                                key={key}
                                tooltip={DONATION_TYPES[key]?.title}
                                icon={DONATION_TYPES[key]?.icon}
                                count={user?.donation_agg[key]}
                                iconStyle={{
                                  width: "24px",
                                  height: "24px",
                                  margin: "8px",
                                }}
                              />
                            );
                      })
                      : Object.keys(DONATION_TYPES)
                        .slice(0, 5)
                        .map((key) => {
                          return (
                            <MainDonationTypes
                              key={key}
                              tooltip={DONATION_TYPES[key]?.title}
                              icon={DONATION_TYPES[key]?.icon}
                              count={
                                user?.donation_agg && user?.donation_agg[key]
                              }
                              iconStyle={{
                                width: "24px",
                                height: "24px",
                                margin: "8px",
                              }}
                            />
                          );
                        })}
                  </div>
                  <div className={styles.DonationInfoMobile}>
                    <p
                      className={styles.MainInfo__donorStatus}
                      style={{
                        backgroundColor: `${user?.donor_status?.background_color}`,
                        color: `${user?.donor_status?.text_color}`,
                      }}
                    >
                      {user?.donor_status?.name}
                    </p>
                    <div className={styles.DonationAgg}>
                      <span className={styles.DonationAgg__count}>
                        {user?.donation_agg?.count}
                      </span>
                      <span className={styles.DonationAgg__text}>
                        {plural(
                          user?.donation_agg?.count,
                          "донация",
                          "донации",
                          "донаций"
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={styles.mobileShareBlock}>
                  <div
                    onClick={handleCaptureClick}
                    className={styles.shareButton}
                  >
                    <span>Рассказать друзьям</span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 6H17.8C16.1198 6 15.2798 6 14.638 6.32698C14.0735 6.6146 13.6146 7.07354 13.327 7.63803C13 8.27976 13 9.11984 13 10.8V12M21 6L18 3M21 6L18 9M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14" stroke="#F73E3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
                <DonorPath honor={honor} />
              </>
            )
          ) : (
            <div style={{ padding: "0 0 12px" }}>
              <div className={styles.MainInfoMobile}>
                <div
                  className={`${styles.MainInfo__mobileAvatarAndName} ${styles.MobileAvatarAndName}`}
                >
                  {
                    user?.profile_config?.photo_style !== 'default_style' &&
                    <img
                      src={user?.blood_group && user?.blood_group !== "dont_know"
                        ? `/static/images/avatars/${user?.profile_config?.photo_style}/${user?.blood_group}.png`
                        : `/static/images/avatars/${user?.profile_config?.photo_style}/without_group.png`}
                      alt=""
                      className={styles.avatarRound}
                    />
                  }
                  <Image
                    className={styles.MobileAvatarAndName__img}
                    src={userAvatar || profileImg}
                    loader={() => userAvatar || profileImg}
                    width={65}
                    height={65}
                    alt="avatar"
                    onClick={() => redirectTo('/profile/settings/personal')}
                  />
                  <span className={styles.MobileAvatarAndName__name}>
                    {user?.first_name}
                  </span>
                  <span className={styles.MobileAvatarAndName__lastName}>
                    {user?.last_name ? user?.last_name : ""}
                  </span>
                </div>
                <div className={styles.More} onClick={toggleVisibleInfo}>
                  <span className={styles.More__text}>Развернуть</span>
                  <Image
                    className={styles.More__img}
                    src={rightArrowimg}
                    alt="arrow"
                    width={28}
                    height={28}
                  />
                </div>
              </div>
              <div className={styles.MainInfoMobileBtn}>
                <Link href={"/profile/add_donation"}>
                  <MyButton
                    text={"Добавить донацию"}
                    width={"312px"}
                    containerWidth={"312px"}
                    onClick={() => {
                      sendMetrics("to_add_donation_from_profile");
                    }}
                  />
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      {visibleInfo && (
        <button className={styles.Collapse} onClick={toggleVisibleInfo}>
          <Image
            className={styles.Collapse__img}
            src={arrowImg}
            alt="arrow"
            width={24}
            height={24}
          />
          <span className={styles.Collapse__text}>Свернуть</span>
        </button>
      )}
    </>
  );
};

export default inject("authStore")(observer(MainInfo));
